module.exports = "<h1>Code, ahoy!</h1>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/08-live-code/02.pug
// module id = 340
// module chunks = 1